export default "__VITE_PUBLIC_ASSET__3c36c239__"